import { useSelector } from 'react-redux';
import { getProcessedListSelector } from 'bento-ordering/base/reducers/bentoApi';

function useLockedPromotions() {
  const promotions = useSelector(state => state.promotions);
  const allPromotions = getProcessedListSelector(promotions);
  return allPromotions.filter(promotion => !promotion.unlocked);
}

export default useLockedPromotions;
